import { useRef, useState, type ReactNode } from "react"
import Dialog from "@/v2-ui/dialog"
import cn from "@/v2-ui/utils/utils.cn"
import SelectorContext, { type SearchStatus } from "./selector.context"
import SelectorCommand from "./SelectorCommand"

const NOOP = () => {}

export type SelectorDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  className?: string
  children: ReactNode
}

function SelectorDialog(props: SelectorDialogProps) {
  const { open, onOpenChange, title, description, className, children } = props
  const [searchStatus, setSearchStatus] = useState<SearchStatus>("idle")
  const minSearchLengthRef = useRef(0)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content
        className={cn("selector-dialog-content", className)}
        align="top"
      >
        <Dialog.Header className="selector-dialog-header">
          <Dialog.Title>{title}</Dialog.Title>
          {description && (
            <Dialog.Description>{description}</Dialog.Description>
          )}
        </Dialog.Header>

        <SelectorContext.Provider
          value={{
            isLoading: false,
            setIsLoading: NOOP,
            shouldFilter: false,
            portal: false,
            searchStatus,
            setSearchStatus,
            minSearchLengthRef,
          }}
        >
          <SelectorCommand shouldFilter={false}>{children}</SelectorCommand>
        </SelectorContext.Provider>
      </Dialog.Content>
    </Dialog>
  )
}

export default SelectorDialog
